export const formatCurrency = (amount, currency = "PKR") => {
  const locale = {
    PKR: "en-PK",
    USD: "en-US",
    EUR: "de-DE",
    SAR: "ar-SA",
    AED: "en-AE",
  };

  return new Intl.NumberFormat(locale[currency] || "en-US", {
    style: "currency",
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amount || 0);
};